import { TFunction } from "i18next";

export const setDangerouslyInnerHtml = (
  translation: TFunction,
  translationKey: string,
  translationParams?: any
): any => {
  return {
    __html: translation(translationKey, translationParams),
  };
};
